"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getChildren;

require("react");

var _get2 = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildren(node, config) {
  var fields = (0, _get2.default)(node, ['fields']);

  if (fields) {
    return fields.map(function (fieldKey) {
      var field = config.fields[fieldKey];

      if (!field) {
        throw new Error("[getLayoutObjectChildren] expected field at \"fields.".concat(fieldKey, "\""));
      }

      return field;
    });
  }

  var children = (0, _get2.default)(node, ['children']);

  if (children) {
    return children.map(function (_ref) {
      var type = _ref.type,
          configPath = _ref.configPath;
      var layoutObject = (0, _get2.default)(config, configPath);

      if (!layoutObject) {
        throw new Error("[getLayoutObjectChildren] expected ".concat(type, " as \"").concat(configPath, "\""));
      }

      return layoutObject;
    });
  }

  return [];
}